import React from 'react';
import './icon.scss';
import { IconProps } from '../../types/icons';

const CarIcon: React.FC<IconProps> = ({
  fill,
  color,
  width = 24,
  height,
  onClick,
  className = '',
  direction = '',
}) => {
  const classBase = 'custom-icon';
  const classes = `${classBase} ${classBase}-color-${color} ${className} ${direction}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height || width}
      className={classes}
      fill={fill || '#7E8A96'}
      onClick={onClick}
      data-testid="car-icon"
      viewBox="0 0 25 24"
    >
      <path
        fill={fill || '#7E8A96'}
        fillRule="evenodd"
        stroke={fill || '#7E8A96'}
        strokeWidth="0.5"
        d="M17.846 7.75a.25.25 0 01.177.074l2.39 2.409a1.75 1.75 0 001.242.517h.678a.25.25 0 01.25.25v3a.25.25 0 01-.25.25h-1a.75.75 0 000 1.5h1a1.75 1.75 0 001.75-1.75v-3a1.75 1.75 0 00-1.75-1.75h-.678a.25.25 0 01-.178-.074l-2.39-2.409a1.75 1.75 0 00-1.241-.517h-7.18a1.75 1.75 0 00-1.05.35l-3.51 2.633a.25.25 0 01-.125.048l-2.921.293A2.75 2.75 0 00.583 12.31V14c0 .966.784 1.75 1.75 1.75h3a.75.75 0 000-1.5h-3a.25.25 0 01-.25-.25v-1.69c0-.642.487-1.18 1.126-1.244l2.922-.292c.317-.032.62-.15.876-.341l3.51-2.633a.25.25 0 01.15-.05h7.179zM17.084 15a.75.75 0 00-.75-.75h-6a.75.75 0 000 1.5h6a.75.75 0 00.75-.75z"
        clipRule="evenodd"
      />
      <path
        fill={fill || '#7E8A96'}
        fillRule="evenodd"
        stroke={fill || '#7E8A96'}
        strokeWidth="0.5"
        d="M18.834 14.75a.75.75 0 110 1.5.75.75 0 010-1.5zm2.25.75a2.25 2.25 0 10-4.5 0 2.25 2.25 0 004.5 0zM7.833 14.75a.75.75 0 110 1.5.75.75 0 010-1.5zm2.25.75a2.25 2.25 0 10-4.5 0 2.25 2.25 0 004.5 0zM14.334 4.25a.75.75 0 00-.75.75v1a.75.75 0 001.5 0V5a.75.75 0 00-.75-.75z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export default CarIcon;
